const axios = require('axios');
const { Buffer } = require('buffer');

export function checkHeicFtyp(input) {
    if (typeof input === 'string' && (input.startsWith('http://') || input.startsWith('https://'))) {
        return checkHeicFtypByUrl(input);
    } else {
        return checkHeicFtypByFile(input);
    }
}

function checkHeicFtypByUrl(url) {
    return axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer',
        headers: { Range: 'bytes=0-11' },
    })
        .then(response => {
            if (response.status !== 206 && response.status !== 200) {
                throw new Error(`Failed to fetch data: HTTP status ${response.status}`);
            }
            if (response.data.length < 12) {
                throw new Error('Insufficient data received');
            }
            const buffer = Buffer.from(response.data);
            return checkBufferHeicFtyp(buffer);
        })
        .catch(error => {
            console.error('Error fetching or parsing the file:', error.message);
            return false;
        });
}

function checkHeicFtypByFile(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = function () {
            const data = reader.result;

            const buffer = Buffer.from(data);

            if (data.length < 12) {
                reject(new Error('Fils too small to contain required data'));
                return;
            }

            resolve(checkBufferHeicFtyp(buffer.slice(0, 12)));
        };

        reader.onerror = function () {
            reject(new Error('Fialed to read file'));
        };

        reader.readAsArrayBuffer(file);
    });
}

function checkBufferHeicFtyp(buffer) {
    const ftyp = buffer.toString('ascii', 4, 8);
    if (ftyp !== 'ftyp') {
        return false;
    }

    const majorBrand = buffer.toString('ascii', 8, 12);
    if (!majorBrand) {
        return false;
    }

    const heicBrands = ['heic', 'heix'];
    return heicBrands.includes(majorBrand);
}

function generateRotatedImage(url, rotation, name) {
    return new Promise(async (resolve, reject) => {
        try {
            const image = new Image();
            image.crossOrigin = 'anonymous';
            image.src = url;

            image.onload = async () => {
                const rotatedBlob = await rotateImageToBlob(image, rotation);

                const file = blob2File(rotatedBlob, name);
                resolve(file);
            };

            image.onerror = () => {
                console.error('image rotate error');
                reject(error);
            };
        } catch (error) {
            reject(error);
        }
    });
}

/**
 * Rotates an image and returns the rotated copy as a Blob.
 * @param {HTMLImageElement} image - The source image to rotate.
 * @param {number} angle - The angle to rotate the image in degrees (clockwise).
 * @param {string} mimeType - The MIME type of the output image (e.g., 'image/png', 'image/jpeg').
 * @param {number} quality - The quality of the output image (for lossy formats like JPEG, range 0-1).
 * @returns {Promise<Blob>} A Promise that resolves with the rotated image as a Blob.
 */
function rotateImageToBlob(image, angle, mimeType = 'image/png', quality = 1) {
    return new Promise((resolve, reject) => {
        try {
            // Create a canvas to draw the rotated image
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // Calculate the dimensions of the rotated image
            canvas.width = angle % 180 === 0 ? image.width : image.height;
            canvas.height = angle % 180 === 0 ? image.height : image.width;

            //Center the canvas
            ctx.translate(canvas.width / 2, canvas.height / 2);

            // Convert the angle to radians
            const radians = (angle * Math.PI) / 180;

            // Rotate the canvas
            ctx.rotate(radians);

            // Draw the image onto the rotated canvas
            ctx.drawImage(image, -image.width / 2, -image.height / 2);

            canvas.toBlob(
                blob => {
                    if (blob) {
                        resolve(blob);
                    } else {
                        reject(new Error('Canvas toBlob failed'));
                    }
                },
                mimeType,
                quality,
            );
        } catch (error) {
            reject(error);
        }
    });
}

export function blob2File(blob, fileName) {
    return new File([blob], fileName, {
        lastModified: new Date(),
        type: blob.type,
    });
}
